<template>
    <div id="apps">
        <AppBreadCrumb :paths="[{ title: $t('message.getApps') }]" />
        <b-container fluid class="mt-3" elavation="0">
            <md-card>
                <md-card-content>
                    <div class="align-items-start">
                        <div>
                            <h4 class="mr-auto font-color">{{ $t("message.downloadMobileApps") }}</h4>
                            <p class="font-color">
                                {{ $t("message.meetWithSupsis") }}
                                <span style="font-weight: 500"> {{ $t("message.clickStoreIcon") }} </span>
                            </p>
                        </div>
                        <div class="icon-container">
                            <a
                                class="links"
                                href="https://play.google.com/store/apps/details?id=com.softcand.supsis&hl=en_ZA&gl=US"
                                target="_blank"
                            >
                                <GooglePlay />
                            </a>
                            <a class="links" href="https://apps.apple.com/ua/app/supsis/id1559749083" target="_blank">
                                <AppleStore />
                            </a>
                        </div>
                    </div>
                </md-card-content>
            </md-card>
        </b-container>
        <b-container fluid class="mt-3" elavation="0">
            <md-card>
                <md-card-content>
                    <div class="align-items-start">
                        <div class="mr-auto">
                            <div>
                                <h4 class="font-color">{{ $t("message.weLlSendPhone") }}</h4>
                                <p class="font-color">{{ $t("message.offerlinkSendToPhone") }}</p>
                            </div>
                            <md-field>
                                <label class="font-color">{{ $t("message.phone") }}</label>
                                <md-input
                                    :label="$t('message.phone')"
                                    autocomplete="off"
                                    trim
                                    type="tel"
                                    v-model="phone"
                                    v-mask="'(###) ### ## ##'"
                                    class="font-color"
                                />
                            </md-field>
                            <md-button
                                @click="send"
                                class="font-color md-dense md-raised md-primary m-0"
                                :disabled="phone.length < 15"
                                >{{ $t("message.send") }}
                            </md-button>
                        </div>
                    </div>
                </md-card-content>
            </md-card>
        </b-container>
        <b-container fluid class="mt-3" elavation="0">
            <md-card>
                <md-card-content>
                    <div class="align-items-start">
                        <div class="mr-auto">
                            <div>
                                <h4 class="font-color">{{ $t("message.weLlSendEmail") }}</h4>
                                <p class="font-color">{{ $t("message.offerlinkSendToMail") }}</p>
                            </div>
                            <div>
                                <md-radio v-model="radio" value="accent" @change="radioControl"
                                    >{{ $t("message.theEmail") }}
                                </md-radio>
                                <md-radio v-model="radio" value="Primary" class="md-primary"
                                    >{{ $t("message.differentEmail") }}
                                </md-radio>
                            </div>
                            <md-field>
                                <label>{{ $t("message.email") }}</label>
                                <md-input
                                    :label="$t('message.email')"
                                    autocomplete="off"
                                    trim
                                    type="tel"
                                    v-model="email"
                                    @change="isEmailValid()"
                                    class="font-color"
                                />
                            </md-field>
                            <md-button
                                @click="send"
                                class="font-color md-dense md-raised md-primary m-0"
                                :disabled="this.validMail === 'classs-error'"
                                >{{ isEmailValid() }}{{ $t("message.send") }}
                            </md-button>
                        </div>
                    </div>
                </md-card-content>
            </md-card>
        </b-container>
        <ChatBar v-if="!isAdmin" :visible="false" />
    </div>
</template>

<script>
import AppBreadCrumb from "../../components/common/AppBreadCrumb";
import ChatBar from "../../components/ChatBar";
import GooglePlay from "../../components/svg/GooglePlay";
import AppleStore from "../../components/svg/AppleStore";
import { mapState } from "vuex";
import Vue from "vue";
import VueTheMask from "vue-the-mask";
import request from "../../utils/request";

Vue.use(VueTheMask);
export default {
    name: "apps",
    components: {
        AppBreadCrumb,
        ChatBar,
        AppleStore,
        GooglePlay,
    },
    computed: {
        ...mapState({
            isAdmin: (state) => state.auth.adminUser != null,
            user: (state) => state.auth.user,
        }),
        radioControl() {
            if (this.radio === "accent") this.email = this.user.email;
            else this.email = "";
        },
    },
    data() {
        return {
            phone: "",
            email: "",
            radio: "accent",
            reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
            validMail: "classs-error",
        };
    },
    methods: {
        isEmailValid: function () {
            const validationControl = this.email == "" ? "" : this.reg.test(this.email) ? "has-success" : "has-error";
            this.validMail = validationControl === "has-success" ? "classs-succes" : "classs-error";
        },
        async send() {
            if (!!this.phone) {
                try {
                    // await request.post("/sms", {
                    //     phone: this.phone,
                    // });
                    this.$toasted.show(this.$t("message.linkSentToPhone"), {
                        duration: 3000,
                        position: "bottom-center",
                    });
                } catch (e) {
                    this.$toasted.error(this.$t("message.errorOccurred"), {
                        duration: 3000,
                        position: "bottom-center",
                    });
                }
            } else if (!!this.email) {
                try {
                    await request.post("/email/supsis-mobile-app-link", {
                        email: this.email,
                    });
                    this.$toasted.show(this.$t("message.linkSentToMailBox"), {
                        duration: 3000,
                        position: "bottom-center",
                    });
                } catch (e) {
                    this.$toasted.error(this.$t("message.errorOccurred"), {
                        duration: 3000,
                        position: "bottom-center",
                    });
                }
            } else return;
        },
    },

    watch() {
        this.email = this.user.email;
    },
};
</script>

<style lang="scss" scoped>
.align-items-start {
    .icon-container {
        display: flex;
        width: 80px;
        height: 80px;
        text-align: center;
        align-items: center;

        a {
            width: 100%;
            height: 100%;
            cursor: pointer;
            transition: 300ms;

            &:hover {
                transform: translateY(-12px);
            }

            svg {
                width: 100%;
                height: 100%;

                &:hover {
                    -webkit-box-shadow: 0px 20px 63px -24px rgba(61, 61, 61, 1);
                    -moz-box-shadow: 0px 20px 63px -24px rgba(61, 61, 61, 1);
                    box-shadow: 0px 20px 63px -24px rgba(61, 61, 61, 1);
                }
            }

            &:not(:last-child) {
                margin-right: 10px;
            }
        }

        .links {
            display: block;
            box-sizing: border-box;
            width: 120px;
            height: 120px;
        }
    }
}

.md-field {
    width: 15%;
}
</style>
